import { render, staticRenderFns } from "./VEnumSpan.vue?vue&type=template&id=2b029cfa&"
import script from "./VEnumSpan.vue?vue&type=script&lang=js&"
export * from "./VEnumSpan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports